<div class="header spacer-bottom tw-fixed tw-top-0 tw-left-0 tw-z-50 tw-w-full">
    <div class="tw-flex tw-items-center">
        <div
            class="flex-grow-0 tw-flex tw-h-full tw-items-center tw-bg-white tw-px-4"
            [ngClass]="isLoggedIn() && !isExternal() ? 'tw-flex' : ''">
            <!-- The logo is a CSS background, so the anchor has no text of its
                 own. Without an explicit name it is an unnamed link on every
                 page of the application. -->
            <a
                class="claim tw-block tw-w-[200px] tw-cursor-pointer"
                [attr.aria-label]="'HEADER.HOME-LINK' | translate"
                [routerLink]="['/']"></a>
        </div>

        @if (isLoggedIn() && !isExternal()) {
            <div class="tw-flex tw-w-full tw-flex-col tw-px-6 tw-gap-0">
                @if (sessionService.isServiceProvider) {
                    <div>
                        <div class="tw-font-bold">
                            {{
                                'ADMIN-PANEL.USERS.ROLES.SERVICEPROVIDER'
                                    | translate
                            }}
                        </div>
                    </div>
                }
                @if (
                    location.path().startsWith('/admin') &&
                    sessionService.isOrganizationAdmin
                ) {
                    <div>
                        <div class="tw-font-bold tw-m-0">
                            {{ 'ADMIN-PANEL.USERS.ROLES.ORGADMIN' | translate }}
                        </div>
                    </div>
                }
                @if (
                    currentSiteRole() && !location.path().startsWith('/admin')
                ) {
                    <div>
                        <div class="tw-font-bold tw-leading-none tw-m-0">
                            {{
                                'HEADER.ROLES.' + currentSiteRole()?.role
                                    | uppercase
                                    | translate
                            }}
                        </div>
                        <!-- <div class="tw-text-xs">
            {{ organisationName }}/{{ currentSiteRole()?.siteInfo?.name }}
          </div> -->
                        <div class="tw-text-sm tw-leading-snug tw-m-0">
                            {{ currentSiteRole()?.siteInfo?.fullSiteName }}
                        </div>
                    </div>
                }
                @if (
                    sessionService.isSiteAdmin &&
                    !sessionService.isOrganizationAdmin
                ) {
                    <div>
                        <div class="tw-font-bold tw-leading-none tw-m-0">
                            {{ 'HEADER.ROLES.SITEADMIN' | translate }}
                        </div>
                    </div>
                }
            </div>
        }
        @if (appConfig.languageSwitcher) {
            <div
                class="language-select has-pointer md:!tw-flex"
                aria-label="language-switcher"
                [matMenuTriggerFor]="languageMenu"
                [matTooltip]="'HEADER.LANGUAGE-SELECTION' | translate">
                <mat-icon fontSet="material-symbols-outlined"
                    >language</mat-icon
                >
                <span class="ms-1">{{ currentLanguage() | translate }}</span>
            </div>
        }
        <mat-menu #languageMenu="matMenu">
            @for (language of availableLanguages; track language.code) {
                <button
                    mat-menu-item
                    (click)="changeLanguage(language.code)">
                    {{ language.label }}
                </button>
            }
        </mat-menu>

        <div class="tw-flex">
            @if (!isExternal() && userSession()) {
                <app-user-profile
                    [userSession]="userSession()"
                    [isExternal]="isExternal()"></app-user-profile>
            }
            @if (canSelectAdminPanel()) {
                <button
                    class="!tw-text-white tw-whitespace-nowrap"
                    mat-button
                    [routerLink]="['/admin']">
                    {{ 'ADMIN-PANEL.TITLE' | translate }}
                </button>
            }
            @if (isLoggedIn() && !isExternal()) {
                <button
                    class="!tw-text-white"
                    mat-button
                    id="logout-button"
                    [attr.aria-label]="'HEADER.LOGOUT' | translate"
                    [matTooltip]="'HEADER.LOGOUT' | translate"
                    (click)="sessionService.logout()">
                    <mat-icon fontSet="material-symbols-outlined"
                        >logout</mat-icon
                    >
                </button>
            }
        </div>
    </div>
</div>
